import { observer } from 'mobx-react-lite';

import type { DifferenceDeliverySlot } from '~/components/ModalSlotsChangedEvent/interfaces';
import { useDeliverySlotDates } from '~/components/ModalSlotsChangedEvent/useDeliverySlotDates';
import { cartStore } from '~/stores';

import { DeliveryDifferenceProduct } from '../DeliveryDifferenceProduct';

import styles from './DeliveryDifferenceItem.module.scss';

const DeliveryDifferenceItem = ({
  differenceItem,
}: {
  differenceItem: DifferenceDeliverySlot;
}) => {
  const { selectedDay, previousSelectedDate } = useDeliverySlotDates({
    slot: differenceItem.slot,
    previousDeliverySlot: differenceItem.previousDeliverySlot,
    expressDeliveryLabelClassName: styles.expressDeliveryLabel,
  });

  const deliveryItems = cartStore.selectedCartItems.filter(({ sku }) =>
    differenceItem.itemsIds.includes(sku),
  );

  return (
    <div className={styles.root}>
      <div className={styles.timeInfo}>
        <span className={styles.previousDate}>{previousSelectedDate}</span>
        <p className={styles.currentDate}>{selectedDay}</p>
      </div>

      <div className={styles.productsGrid}>
        {deliveryItems.map((cartItem) => (
          <DeliveryDifferenceProduct cartItem={cartItem} key={cartItem.id} />
        ))}
      </div>
    </div>
  );
};

export default observer(DeliveryDifferenceItem);
